import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';

export const canActivateAdmin: CanActivateFn = async () => {
  const service = inject(AuthenticationService);
  const isAdmin = await service.isAdmin();
  return !!isAdmin;
};
